import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/deep-dive-section/assets/deep-dive.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')